import React from "react";
import formImg from "../../assets/backgrounds/homepage.jpg";
import GeneralStrings from "../../strings/GeneralStrings.json";
import "./EnrollForm.scss";
import * as Yup from "yup";
import "yup-phone";
// import "./enroll-multi-step-form.js";
import AlertStrings from "../../strings/AlertStrings.json";
import { Form, Formik } from "formik";
import NameStep from "./FormSteps/NameStep";
import { Button } from "@mui/material";
import ContactInfoStep from "./FormSteps/ContactInfoStep.jsx";
import AddressStep from "./FormSteps/AddressStep.jsx";
import PoolTypeStep from "./FormSteps/PoolTypeStep.jsx";
import PoolHeatedStep from "./FormSteps/PoolHeatedStep.jsx";
import AboutTheSwimmersStep from "./FormSteps/AboutTheSwimmersStep.jsx";
import PackagingStep from "./FormSteps/PackagingStep.jsx";
import AvailabilityStep from "./FormSteps/AvailabilityStep.jsx";
import TimeStep from "./FormSteps/TimeStep.jsx";
import NumberOfLessonsStep from "./FormSteps/NumberOfLessonsStep.jsx";
import StartDateStep from "./FormSteps/StartDateStep.jsx";
import Recaptcha from "react-recaptcha";
import NotesStep from "./FormSteps/NotesStep.jsx";
import TermsStep from "./FormSteps/TermsStep.jsx";

const EnrollForm = ({
  isLoading,
  handleSubmit,
  recaptchaLoaded,
  verifiedRecaptcha,
}) => {
  const ENROLL_STRINGS = GeneralStrings.ENROLL;

  const digitsOnly = (value) => /^\d+$/.test(value);

  const ContactFormSchema = Yup.object().shape({
    phoneNumber: Yup.string()
      .required(AlertStrings.FORM_VALIDATION.PHONE_NUMBER_REQUIRED)
      .test(
        AlertStrings.FORM_VALIDATION.DIGITS_ONLY,
        AlertStrings.FORM_VALIDATION.NUMBERS_ONLY_ALLOWED,
        digitsOnly
      )
      .min(7, AlertStrings.FORM_VALIDATION.ENTER_PHONE_NUMBER)
      .max(10, AlertStrings.FORM_VALIDATION.PHONE_NUMBER_TOO_LONG),
  });

  return (
    <div className="enroll-form">
      <div className="container enroll-form-container">
        <div className="row">
          {/* Title */}
          <div className="col-lg-4 offset-lg-1 title-container">
            <div className="title-content">
              <img
                className="title-container-image rounded-circle"
                src={formImg}
                alt="Diving Board"
              />
              <h2>{GeneralStrings.MAKE_A_WAVE}</h2>
              <h3>{ENROLL_STRINGS.ENROLLMENT_FORM}</h3>
              <p>{ENROLL_STRINGS.ENROLLMENT_FORM_DESCRIPTION}</p>
            </div>
          </div>
          {/* Form Steps */}
          <div className="col-lg-7 multi-form-container">
            <div className="progress">
              <div
                aria-valuemax="100"
                aria-valuemin="0"
                aria-valuenow="50"
                className="progress-bar progress-bar-striped progress-bar-animated bg-info"
                role="progressbar"
                style={{ width: "0%" }}
              ></div>
            </div>
            <div className="form-container">
              <Formik
                initialValues={{
                  firstName: "",
                  lastName: "",
                  email: "",
                  phoneNumber: "",
                  address: "",
                  poolType: "",
                  heatedPool: "",
                  numberOfSwimmers: "",
                  swimmerName: "",
                  swimmerAge: "",
                  waterComfortLevel: "",
                  levelOfSwimming: "",
                  swimmingPackage: "",
                  weekdayAvailability: "",
                  weekdayAvailabilityTime: "",
                  numberOfLessonsPerWeek: "",
                  startDate: "",
                  /* paymentType: "", */
                  notes: "",
                  termsAndConditionsAcceptance: "",
                }}
                validationSchema={ContactFormSchema}
                onSubmit={(values) => {
                  handleSubmit(values);
                }}
              >
                {(values) => (
                  <Form className="form">
                    <NameStep />
                    <ContactInfoStep />
                    <AddressStep />
                    <PoolTypeStep />
                    <PoolHeatedStep />
                    <AboutTheSwimmersStep />
                    <PackagingStep
                      numberOfSwimmers={values.values.numberOfSwimmers}
                    />
                    <AvailabilityStep />
                    <TimeStep />
                    <NumberOfLessonsStep />
                    <StartDateStep />
                    <NotesStep />
                    <TermsStep />
                    <div className="form-group">
                      <Recaptcha
                        sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                        render="explicit"
                        onloadCallback={recaptchaLoaded}
                        verifyCallback={verifiedRecaptcha}
                      />
                    </div>
                    <div className="form-group btn-container">
                      {/* <Button
                      id="prev-btn"
                      variant="contained"
                      disabled={isLoading}
                      loading={isLoading}
                      className="form-button"
                      type="button"
                    >
                      {GeneralStrings.FORM.PREVIOUS}
                    </Button>
                    <Button
                      id="next-btn"
                      variant="contained"
                      disabled={isLoading}
                      loading={isLoading}
                      className="form-button"
                      type="button"
                    >
                      {GeneralStrings.FORM.NEXT}
                    </Button> */}
                      <Button
                        id="submit-btn"
                        variant="contained"
                        disabled={isLoading}
                        loading={isLoading}
                        className="form-button submit"
                        type="submit"
                      >
                        {GeneralStrings.FORM.SUBMIT}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnrollForm;
